import { create } from 'zustand';
import type { MagicMenuItem } from './types';

interface MagicMenuStoreState {
  readonly items: readonly MagicMenuItem[];
  /** True jakmile dorazila první `desktop/menu-ready` zpráva z Magic control instance. */
  readonly isReady: boolean;
  /**
   * True, když se nepodařilo načíst hlavní plochu Magicu (opakovaně selhal redeem/auth — viz
   * pojistka proti zacyklení v `MagicControlBridge`). Místo věčného načítacího kolečka „Magic2G"
   * se v liště zobrazí chyba.
   */
  readonly loadError: boolean;
  readonly setItems: (items: readonly MagicMenuItem[]) => void;
  readonly setLoadError: (loadError: boolean) => void;
  readonly reset: () => void;
}

export const useMagicMenuStore = create<MagicMenuStoreState>((set) => ({
  items: [],
  isReady: false,
  loadError: false,
  // Úspěšné menu-ready zároveň smaže případnou chybu.
  setItems: (items) => set({ items, isReady: true, loadError: false }),
  setLoadError: (loadError) => set({ loadError }),
  reset: () => set({ items: [], isReady: false, loadError: false }),
}));
